var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1365 17.75H1.63647C0.94585 17.75 0.386475 17.1907 0.386475 16.5V10.875C0.386475 10.1844 0.94585 9.62503 1.63647 9.62503H4.9696V9.00003C4.9696 8.3094 5.5296 7.75003 6.2196 7.75003H9.55335V6.50003C9.55335 5.8094 10.1127 5.25003 10.8033 5.25003H14.1365C14.8271 5.25003 15.3865 5.8094 15.3865 6.50003V16.5C15.3865 17.1907 14.8271 17.75 14.1365 17.75ZM4.9696 10.875H1.63647V16.5H4.9696V10.875ZM9.55335 9.00003H6.2196V16.5H9.55335V9.00003ZM10.8033 16.5H14.1365V6.50003H10.8033V8.37503V16.5ZM9.75272 2.51378C7.40085 5.98128 3.04147 7.10565 3.04147 7.10565C2.7071 7.19128 2.36647 6.9894 2.28085 6.65503C2.19522 6.32065 2.3971 5.98003 2.73147 5.8944C2.73147 5.8944 6.88273 4.84253 8.9121 1.51065L7.68272 1.50003C7.33772 1.4969 7.06022 1.2144 7.06335 0.869401C7.06647 0.524401 7.34897 0.246901 7.69397 0.250026L10.369 0.273776C10.7102 0.276276 10.9858 0.551901 10.9883 0.893151L11.0115 3.50628C11.0146 3.85128 10.7371 4.13378 10.3921 4.1369C10.0471 4.14003 9.7646 3.86253 9.76147 3.51753L9.75272 2.51378Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsoutline);
export default __webpack_public_path__ + "static/media/reports.outline.92295a693b1e15bbe60edf678e8a8828.svg";
export { ForwardRef as ReactComponent };